const actionScope = '[Location States]';

export class LoadStates {
  static readonly type = `${actionScope} Load States`;

  constructor(public countryId: number) {}
}
